<template>
  <div>
    <el-select v-model="value" :placeholder="`请选择${title}`" @change="changeselect">
      <el-option v-for="item in list" :key="item.value" :label="item.label" :value="item.value">
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      value: ''
    };
  },
  watch: {
    content: {
      handler(val) {
        this.value = val;
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    changeselect(e) {
      this.$emit('changeselect', e);
    }
  }
};
</script>

<style lang="scss" scoped></style>